exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "calendar-inline-header .days-header-container{display:flex}calendar-inline-header .dn{background-color:hsla(220,8%,92%,.5);padding-left:6px;padding-top:12px;min-width:36.14px;height:40px;font-family:Stag Sans;font-size:12px;text-align:center;color:#666}calendar-inline-header .Do,calendar-inline-header .Sa{font-weight:300}calendar-inline-header .Do{border-right:1px solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHeader/calendarInlineHeader.scss
// module id = 1479
// module chunks = 0